// ✅ 최종 수정된 TopAppBar.js

import React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'
import { Link, useLocation } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import '/node_modules/flag-icons/css/flag-icons.min.css'
import i18n from '../i18n'

function TopAppBar () {
  const pages = ['blog', 'books', 'testimonials', 'faq']
  const [anchorElNav, setAnchorElNav] = React.useState(null)
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const [showTooltip, setShowTooltip] = React.useState(() => {
    return !localStorage.getItem('hasVisited')
  })

  const handleClickOutside = React.useCallback((event) => {
    // Check if the click is outside the tooltip and flag
    const tooltipElement = document.querySelector('.MuiTooltip-tooltip');
    const flagElement = document.querySelector('.fi-kr');
    
    if (tooltipElement && !tooltipElement.contains(event.target) && 
        flagElement && !flagElement.contains(event.target) && 
        !flagElement.parentElement.contains(event.target)) {
      setShowTooltip(false);
      localStorage.setItem('hasVisited', 'true');
    }
  }, []);

  React.useEffect(() => {
    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
      const timer = setTimeout(() => {
        setShowTooltip(false);
        localStorage.setItem('hasVisited', 'true');
      }, 3000);
      
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        clearTimeout(timer);
      };
    }
  }, [showTooltip, handleClickOutside]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
    localStorage.setItem('lng', lng)
  }

  const getIsActive = (page) => {
    return location.pathname.includes(page)
  }

  return (
    <AppBar position='fixed' sx={{ background: '#2E3B55' }}>
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          {/* 데스크탑 로고 */}
          <Typography
            variant='h6'
            noWrap
            component='a'
            href='/'
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            Hyunjin Jae
          </Typography>

          {/* 모바일 메뉴버튼 */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='menu'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography
                    textAlign='center'
                    sx={{ textTransform: 'uppercase', fontSize: 14 }}
                  >
                    <Link
                      to={`/${page}`}
                      style={{ textDecoration: 'none', color: 'black' }}
                    >
                      {page}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* 모바일 로고 */}
          <Typography
            variant='h5'
            noWrap
            component='a'
            href='/'
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            HYUNJIN
          </Typography>

          {/* 데스크탑 메뉴 */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => {
              const isActive = getIsActive(page)
              return (
                <Button
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    display: 'block',
                    color: isActive ? 'white' : 'white',
                    fontWeight: isActive ? 'bold' : 'normal',
                    opacity: isActive ? 1 : 0.65,
                    borderBottom: isActive ? '2px solid white' : 'none',
                    borderRadius: 0,
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Link
                    to={`/${page}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {page.toUpperCase()}
                  </Link>
                </Button>
              )
            })}
          </Box>

          {/* 언어 선택 영역 */}
          <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* 한국어 - 첫 방문 시 툴팁 (모든 디바이스) */}
            {showTooltip && (
            <Tooltip 
              title="한국어로 보고 싶다면 태극기를 눌러주세요!"
              open={showTooltip}
              placement="bottom-end"
              arrow
                TransitionComponent={Zoom}
              PopperProps={{
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                      },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        altAxis: true,
                        padding: 8
                      }
                    }
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.98)',
                      color: '#2E3B55',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                      borderRadius: '12px',
                      px: 2,
                      py: 1.5,
                      maxWidth: '250px',
                      textAlign: 'center',
                      border: '1px solid rgba(46, 59, 85, 0.1)',
                      backdropFilter: 'blur(5px)',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(255, 255, 255, 0.98)',
                      }
                    },
                  },
                }}
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    changeLanguage('kr');
                    setShowTooltip(false);
                    localStorage.setItem('hasVisited', 'true');
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    '&:hover': { 
                      transform: 'scale(1.1)',
                      opacity: 1
                    }
                  }}
                >
                  <div className='fi fi-kr' style={{ fontSize: '17px', transform: 'none' }} />
                </Box>
              </Tooltip>
            )}

            {/* 한국어 - 호버 시 툴팁 (데스크탑만) */}
            {!showTooltip && !isMobile && (
              <Tooltip 
                title="한국어로 변경"
                placement="bottom-end"
                arrow
                TransitionComponent={Zoom}
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                  },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        altAxis: true,
                        padding: 8
                      }
                    }
                ],
              }}
              componentsProps={{
                tooltip: {
                  sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.98)',
                      color: '#2E3B55',
                      fontSize: '14px',
                    fontWeight: 'bold',
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                      borderRadius: '12px',
                      px: 2,
                      py: 1.5,
                    maxWidth: '250px',
                    textAlign: 'center',
                      border: '1px solid rgba(46, 59, 85, 0.1)',
                      backdropFilter: 'blur(5px)',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(255, 255, 255, 0.98)',
                      }
                  },
                },
              }}
            >
              <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    changeLanguage('kr');
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    '&:hover': { 
                      transform: 'scale(1.1)',
                      opacity: 1
                    }
                  }}
                >
                  <div className='fi fi-kr' style={{ fontSize: '17px', transform: 'none' }} />
                </Box>
              </Tooltip>
            )}

            {/* 한국어 - 모바일용 (툴팁 없음) */}
            {!showTooltip && isMobile && (
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  changeLanguage('kr');
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  '&:active': { 
                    transform: 'scale(0.95)',
                  }
                }}
              >
                <div className='fi fi-kr' style={{ fontSize: '17px', transform: 'none' }} />
              </Box>
            )}

            {/* 영어 - 툴팁 (데스크탑만) */}
            {!isMobile && (
              <Tooltip 
                title="Translate to Eng"
                placement="bottom-end"
                arrow
                TransitionComponent={Zoom}
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                      },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        altAxis: true,
                        padding: 8
                      }
                    }
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.98)',
                      color: '#2E3B55',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                      borderRadius: '12px',
                      px: 2,
                      py: 1.5,
                      maxWidth: '250px',
                      textAlign: 'center',
                      border: '1px solid rgba(46, 59, 85, 0.1)',
                      backdropFilter: 'blur(5px)',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(255, 255, 255, 0.98)',
                      }
                    },
                  },
                }}
              >
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    changeLanguage('us');
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease',
                    '&:hover': { 
                      transform: 'scale(1.1)',
                      opacity: 1
                    }
                }}
              >
                  <div className='fi fi-us' style={{ fontSize: '17px' }} />
              </Box>
            </Tooltip>
            )}

            {/* 영어 - 모바일용 (툴팁 없음) */}
            {isMobile && (
            <Box
                onClick={(e) => {
                  e.stopPropagation();
                  changeLanguage('us');
                }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  '&:active': { 
                    transform: 'scale(0.95)',
                  }
              }}
            >
              <div className='fi fi-us' style={{ fontSize: '17px' }} />
            </Box>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default TopAppBar
